<div [formGroup]="form" class="grid gap-6">
    <mat-form-field appearance="fill">
        <mat-label>Dagsetning viðskipta</mat-label>
        <input matInput class="date" formControlName="transactionDate" (click)="date.open()" [matDatepicker]="date" />
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
        <mat-error>Dagsetning er skyldureitur</mat-error>
    </mat-form-field>

    <mat-radio-group formControlName="transactionType" class="flex flex-col gap-2">
        <mat-label class="font-medium mb-1">Kaup eða sala?</mat-label>
        <mat-radio-button value="Buy">Kaup</mat-radio-button>
        <mat-radio-button value="Sell">Sala</mat-radio-button>
    </mat-radio-group>

    <mat-form-field class="w-full">
        <mat-label>{{ 'label_interest_register_field_trading_owner_name' | translate }}</mat-label>
        <input matInput formControlName="tradingOwnerName" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Auðkenni / nafn fjármálagernings</mat-label>
        <input matInput formControlName="financialInstrumentName" />
        <mat-error>Þessi reitur er skyldureitur</mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="isPublicOffering"> Almennt útboð </mat-checkbox>

    <mat-form-field appearance="fill">
        <mat-label>Nafnverð</mat-label>
        <input matInput maxlength="11" numericFormat formControlName="nominalValue" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Kaupverð/söluverð</mat-label>
        <input matInput maxlength="11" numericFormat formControlName="transactionPrice" />
        <span matSuffix>kr.</span>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>{{ 'label_interest_register_field_other_information' | translate }}</mat-label>
        <textarea matInput rows="6" formControlName="otherInformation"></textarea>
    </mat-form-field>
</div>
